import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function StickyWhatsApp() {
  return <motion.a href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20extractos%20de%20hongos" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors duration-300" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Consultar por WhatsApp" data-id="element-140">
      <MessageCircle size={32} data-id="element-141" />
    </motion.a>;
}